<template>
  <v-row class="justify-center">
    <!-- Start Single Team Area  -->
    <v-col
      lg="12i"
      md="12i"
      sm="12i"
      cols="12"
      v-for="team in teamContent"
      :key="team.id"
    >
      <div class="team">
        <div class="thumbnail">
          <img :src="team.src" alt="Team Images" />
        </div>
        <div class="content">
          <h4 class="heading-title">{{ team.title }}</h4>
          <p class="designation">{{ team.designation }}</p>
        </div>
        <SocialIcon />
      </div>
    </v-col>
    <!-- End Single Team Area  -->
  </v-row>
</template>

<script>
  import SocialIcon from "../../components/social/Social";
  export default {
    components: {
      SocialIcon,
    },
    data() {
      return {
        teamContent: [
          {
            id: 1,
            src: require("../../assets/images/legals/dti.jpg"),
            title: "DTI",
            designation: "DTI Registration",
          },
          {
            id: 2,
            src: require("../../assets/images/legals/appreciation.jpg"),
            title: "Certificate of Appreciation",
            designation: "Single Ticketing System",
          },
        ],
      };
    },
  };
</script>
